module.exports = __webpack_public_path__ + "img/process.bedc323f.png";